import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      name: '',
      breadList: []
    };
  },
  created: function created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var _this = this;

      console.log('this.$route.matched', this.$route.matched);
      this.breadList = []; // this.breadList.push({ name: 'dashboard', path: '/dashboard/', meta: { title: '首页' } })

      this.name = this.$route.name;
      this.$route.matched.forEach(function (item) {
        item.name === 'dashboard' ? item.path = '/dashboard/Desktop' : _this.$route.path === item.path;

        _this.breadList.push(item);
      }); // console.log(this.breadList)
    }
  },
  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  }
};